module.exports = __webpack_public_path__ + "img/tu4.5b744fd2.png";